import {compressPhotoFile, prepareReportPhotos} from "@mytour/platform";
import type {CertificatRamonagePayload, ReportPhotoInput} from "@mytour/shared";

export class RamonagePhotoPreparationError extends Error {}

export async function prepareCertificatePhotos(
  payload: CertificatRamonagePayload,
  render: (payload: CertificatRamonagePayload) => Promise<Blob>
): Promise<CertificatRamonagePayload> {
  const photos = payload.appareils.flatMap((appareil) => appareil.photos ?? []);
  if (!photos.length) {
    return payload;
  }
  let prepared = payload;
  try {
    await prepareReportPhotos(
      photos,
      async (preparedPhotos) => {
        if (preparedPhotos === photos) {
          return render(payload);
        }
        let offset = 0;
        prepared = {
          ...payload,
          appareils: payload.appareils.map((appareil) => {
            const count = appareil.photos?.length ?? 0;
            const photos: ReportPhotoInput[] = preparedPhotos.slice(offset, offset + count);
            offset += count;
            return {...appareil, photos};
          }),
        };
        return render(prepared);
      },
      compressPhotoFile
    );
    return prepared;
  } catch {
    throw new RamonagePhotoPreparationError(
      "Le PDF avec ces photos ne peut pas être finalisé. Retirez ou remplacez une photo, puis réessayez. Vos saisies sont conservées."
    );
  }
}
